export default __webpack_public_path__ + "static/media/employee_template.838751f4.xlsx";